export const JOB_CARD_ACTION = {
  COMPANY_NAME_LINK: 'companyNameLink',
  IMAGE: 'image',
  JOB_DETAIL_BUTTON: 'jobDetailButton',
  BOOK_MARK_LIST: 'bookmarkList',
} as const;
